import React from 'react';
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';
import useColors from 'hooks/useColors';
import { IconWithGradient } from './Icon';
export const IconCloseSquircle = ({ color, crossColor, ...props }) => {
    const colors = useColors();
    const fill = color || colors.elements.statusNegative;
    const crossColorFill = crossColor || colors.background.dark;
    return (<IconWithGradient {...props} scale={1} defaultColorKey="statusNegative">
      <G clipPath="url(#clip0_9765_17332)">
        <Path fillRule="evenodd" clipRule="evenodd" d="M14.9703 3.3437C13.0166 2.88543 10.9834 2.88543 9.02975 3.3437C6.20842 4.00549 4.0055 6.20841 3.3437 9.02975C2.88543 10.9834 2.88543 13.0166 3.3437 14.9703C4.0055 17.7916 6.20842 19.9945 9.02975 20.6563C10.9834 21.1146 13.0166 21.1146 14.9703 20.6563C17.7916 19.9945 19.9945 17.7916 20.6563 14.9703C21.1146 13.0166 21.1146 10.9834 20.6563 9.02975C19.9945 6.20842 17.7916 4.00549 14.9703 3.3437Z" fill={fill}/>
        <Rect x="15.9844" y="9.41504" width="10" height="2" rx="1" transform="rotate(135 15.9844 9.41504)" fill={crossColorFill}/>
        <Rect x="14.5703" y="16.4854" width="10" height="2" rx="1" transform="rotate(-135 14.5703 16.4854)" fill={crossColorFill}/>
      </G>
      <Defs>
        <ClipPath id="clip0_9765_17332">
          <Rect width="24" height="24" fill={crossColorFill}/>
        </ClipPath>
      </Defs>
    </IconWithGradient>);
};
